import ChatButtomAndDropdown from './ChatButtonAndDropdown';
import connect from './ChatButtonAndDropdown.container';
export default connect(ChatButtomAndDropdown);
//# sourceMappingURL=index.js.map